import { getActions, getGlobal } from '../global';

import type { ApiPeer, ApiUser } from '../api/types';
import type { ActionPayloads } from '../global/types';
import { RightColumnContent } from '../types';

import { isUserBot, isUserId } from '../global/helpers';
import { selectUser } from '../global/selectors';

type OpenPeerOptions = Omit<ActionPayloads['openChat'], 'id'>;

function isApiUser(peer: ApiPeer): peer is ApiUser {
  return peer.type.startsWith('userType');
}

export function shouldOpenPeerInfo(peer: ApiPeer) {
  return shouldOpenPeerIdInfo(peer.id, isApiUser(peer) ? peer : undefined);
}

export function shouldOpenPeerIdInfo(peerId: string, peerUser?: ApiUser) {
  if (!isUserId(peerId)) {
    return false;
  }

  const user = peerUser || selectUser(getGlobal(), peerId);

  return !user || !isUserBot(user);
}

export function openPeerFromUserLink(peer: ApiPeer, options?: OpenPeerOptions) {
  const { openChat, openRightColumnOnly } = getActions();

  if (shouldOpenPeerInfo(peer)) {
    openRightColumnOnly({
      contentKey: RightColumnContent.ShowRightColumnOnly,
      userId: peer.id,
      tabId: options?.tabId,
    });
  } else {
    openChat({ id: peer.id, ...options });
  }
}

export function openPeerIdFromUserLink(peerId: string, options?: OpenPeerOptions) {
  const { openChat, openRightColumnOnly } = getActions();

  if (shouldOpenPeerIdInfo(peerId)) {
    openRightColumnOnly({
      contentKey: RightColumnContent.ShowRightColumnOnly,
      userId: peerId,
      tabId: options?.tabId,
    });
  } else {
    openChat({ id: peerId, ...options });
  }
}
